import { Link } from "react-router-dom";
import { primaryLogoPngUrl } from "@/config/public-assets";
import { useAdminSessionEmail } from "@/hooks/useAdminSessionEmail";
import { layoutMessages } from "./messages";
import { AdminNavItem } from "./AdminNavItem";
import styles from "./AdminSidebar.module.css";

const NAV_SECTIONS = [
  {
    id: "navigate",
    title: layoutMessages.sidebar.sections.navigate,
    items: [
      { to: "/customers", label: layoutMessages.sidebar.nav.customers },
      {
        to: "/account-managers",
        label: layoutMessages.sidebar.nav.accountManagers,
      },
    ],
  },
  {
    id: "system",
    title: layoutMessages.sidebar.sections.system,
    items: [
      { to: "/audit-log", label: layoutMessages.sidebar.nav.auditLog },
      { to: "/settings", label: layoutMessages.sidebar.nav.settings },
    ],
  },
] as const;

export function AdminSidebar() {
  const sessionEmail = useAdminSessionEmail();
  const { sidebar, brand } = layoutMessages;

  return (
    <aside
      className={styles.sidebar}
      aria-label={sidebar.ariaLabel}
      data-testid="admin-sidebar"
    >
      <Link
        to="/customers"
        className={styles.brand}
        data-testid="admin-sidebar-brand"
        aria-label={sidebar.brandAriaLabel}
      >
        <div className={styles.brandText}>
          <img
            className={styles.brandLogoFull}
            src={primaryLogoPngUrl}
            alt={brand.name}
            data-testid="admin-sidebar-brand-logo"
          />
          <p className={styles.brandSub} data-testid="admin-sidebar-brand-subtitle">
            {sidebar.brandLabel}
          </p>
        </div>
      </Link>

      {NAV_SECTIONS.map((section) => (
        <nav
          key={section.id}
          className={styles.navSection}
          aria-labelledby={`admin-nav-${section.id}-heading`}
          data-testid={`admin-sidebar-nav-${section.id}`}
        >
          <h2
            id={`admin-nav-${section.id}-heading`}
            className={styles.sectionTitle}
          >
            {section.title}
          </h2>
          <ul className={styles.navList}>
            {section.items.map((item) => (
              <li key={item.to}>
                <AdminNavItem to={item.to} label={item.label} />
              </li>
            ))}
          </ul>
        </nav>
      ))}

      <div className={styles.footer} data-testid="admin-sidebar-footer">
        <p className={styles.sessionLabel} data-testid="admin-sidebar-session-label">
          {sidebar.sessionLabel}
        </p>
        <p className={styles.sessionEmail} data-testid="admin-sidebar-session-email">
          {sessionEmail || "—"}
        </p>
      </div>
    </aside>
  );
}
